export default {
  productNames: {
    port: `Port`,
    mcr: `MCR`,
    mve: `MVE`,
    vxc: `VXC`,
    ix: `IX`,
    lag: `LAG`,
    megaportInternet: `Megaport Internet`,
  },
  services: {
    'rate-limit': `Rate Limit`,
    'select-rate-limit': `Select Rate Limit`,
    'product-size': `Product Size`,
    'product-type-name': `{type} Name`,
    'select-version': `Select Version`,
    'image-version': `Image Version`,
    'monthly-price': `Monthly Price`,
    'select-port-speed': `Select Port Speed`,
    'transit-vxc-location-warning': `Note: The current service has one or more associated Megaport Internet VXCs. Changing the location may result in the deletion of these VXCs if a suitable match is not found for the new location.`,
    edit: `Edit Service`,
    remove: `Remove Service`,
    'deleting-error': `Error Deleting Service`,
    'deleting-error-long': `Failed to delete service with name: {serviceName}`,
    'exclude-type-from-quote': `Exclude {serviceType} from quote`,
    'exclude-type-help-text': `Exclude this {serviceType} if you need it configured to replicate a particular network design without including its cost in the quote.`,
    'private-service': `Private Service`,
  },
  general: {
    'remove-type': `Remove {type}`,
    'add-type': `Add {type}`,
    'count-months': `0 Months | 1 Month | {count} Months`,
    'max-rate-limit': `MAX: {maxRateLimit} Mbps`,
    'speed-gbps': `{speed} Gbps`,
    save: `Save`,
    close: `Close`,
    cancel: `Cancel`,
    confirm: `Confirm`,
    back: `Back`,
    service: `Service`,
    summary: `Summary`,
    copy: `Copy`,
    'copy-to-clipboard': `Copy to Clipboard`,
    email: `Email`,
    password: `Password`,
    ok: `OK`,
    documentation: `Documentation`,
    yes: `Yes`,
    no: `No`,
    'select-location': `Select Location`,
    'unknown-location': `Unknown Location`,
    'no-matching-countries': `No matching countries`,
    'country-filter': `Country Filter`,
    search: `Search`,
    'pre-order': `Pre-order`,
    term: `Term`,
    status: `Status`,
    'created-by': `Created By`,
    'please-select': `Please select`,
    'important-information': `Important Information`,
    edit: `Edit`,
    'company-name': `Company Name`,
    disable: `Disable`,
    date: `Date`,
    mbps: `Mbps`,
    actions: `Actions`,
    delete: `Delete`,
    location: `Location`,
    add: `Add`,
    token: `Token`,
    'confirm-remove-type': `Are you sure you want to remove this {type}?`,
    change: `Change`,
    'no-matching-rows': `No matching rows`,
    'copy-with-styling': `Copy With Styling`,
    'copy-plain': `Copy Plain Table`,
    'please-confirm': `Please Confirm`,
    total: `Total`,
    enable: `Enable`,
    'network-design': `Network Design`,
    duplicate: `Duplicate`,
    'deal-id': `Deal ID`,
    'created-date': `Created Date`,
    'copied-to-clipboard': `{target} copied to clipboard.`,
    'copy-failed': `Failed to copy to clipboard.`,
    'data-centre-logo': `Data centre logo`,
    'vendor-logo': `Vendor logo`,
    currency: `Currency`,
    'select-currency': `Select Currency`,
    'legal-notice': `Legal notice`,
    retry: `Retry`,
    'unexpected-error': `An unexpected error has occurred. Try again later. If this error persists contact support@megaport.com`,
    'start-over': `Start Over`,
    'existing-customer': `Existing Customer`,
    'potential-customer': `Potential Customer`,
    id: `ID`,
    'copy-full-uuid': `Copy Full UUID`,
    'partner-name': `Partner Name`,
    'customer-account': `Customer Account`,
    'customer-company': `Customer Company`,
    'monthly-term': `Month to Month`,
    unsaved: `Unsaved Changes`,
    'megaport-logo': `Megaport Logo`,
    'company-logo': `{company} Logo`,
    'configure-price-quote': `Configure · Price · Quote`,
    'cloud-service-provider': `Cloud Service Provider`,
    download: `Download`,
    metadata: `Metadata`,
    'show-more-actions': `Show More Actions`,
    'no-minimum-term': `No Minimum Term`,
    excluded: `Excluded`,
    'monthly-subtotal': `Monthly Subtotal`,
    'quoted-price': `Quoted Price`,
    view: `View`,
    deactivated: `Deactivated`,
    unknown: `Unknown`,
  },
  authentication: {
    'password-reset': `Your account requires a password reset. Set a new password here to log in.`,
    'very-weak': `Very Weak`,
    weak: `Weak`,
    moderate: `Moderate`,
    good: `Good`,
    excellent: `Excellent`,
    'log-in': `Log In`,
    'username-email': `Email`,
    'new-password': `New Password`,
    forgot: `Forgot Password`,
    'trying-login': `Trying to log in...`,
    'failed-login': `Failed to log you in with your existing credentials. Log in again.`,
    'logging-in': `Logging in...`,
    'need-to-reset': `You will need to reset your password. The form has been updated with the required field.`,
    failed: `Login Failed`,
    'login-success-message': `Successful Login!`,
    'login-failed-token': `Failed to log you in with your existing token. Please log in again.`,
    'confirm-password': `Confirm Password`,
    'login-error-msg': `We are unable to log in using your credentials. Having trouble with login? <a href="https://www.megaport.com/contact/support/" target="_blank">Get Help</a>`,
    'password-must-include': `Your password must`,
    'at-least-8-char': `Be at least 8 characters`,
    'at-least-one-number': `Have at least one number`,
    'at-least-one-symbol': `Have at least one symbol`,
    'at-least-one-lower-case-letter': `Have at least one lower case letter`,
    'at-least-one-upper-case-letter': `Have at least one upper case letter`,
    'confirm-new-password': `Confirm New Password`,
    'mfa-token-invalid': `One time code {code} is invalid. After 5 consecutive unsuccessful attempts, your account will be locked.`,
    'mfa-reset-customer-portal': `Your MFA has been reset, please sign in through the <a href="{portalUrl}">customer portal</a> to reset MFA before trying to login again`,
    'mfa-enforced-customer-portal': `MFA is now enforced, please sign in through the <a href="{portalUrl}">customer portal</a> to setup MFA before trying to login again`,
    'mfa-token': `Multi-Factor Authentication Token`,
    'mfa-enter-token': `MFA is enabled for your account. Please enter a token to log in.`,
    verify: `Verify`,
    'mfa-verify-token': `Verifying token`,
    'no-access': `Your account does not have access to Megaport Quoting Tool.`,
    'managed-account-no-access': `Managed accounts do not have access to Megaport Quoting Tool. Please contact your Megaport Partner for estimating service cost.`,
    'sso-enforced-no-access': `A Company Administrator has enforced Single Sign-On and you must only login via SSO. Please contact your Company Administrator if you need assistance with SSO access.`,
    'login-sso-help-reset-password': `If you are having issues logging in with your email and password, try resetting your password using the "Forgot Password" link below.`,
    'login-sso-help-idp-config': `If you have Single Sign-On (SSO) enabled but can't log in, there might be an IdP configuration error or your IdP is not responding. You might be able to log in directly using your Megaport username and password if you are a Company Admin or if SSO is set to Optional.`,
    'get-help-signing-in': `Get help signing in`,
    'log-out': `Log Out`,
    'toggle-password-visibility': `Toggle password visibility`,
    'missing-login-data': `Missing login data`,
    'enter-email-before-otp': `You must enter your Email before you can provide a Multi-Factor Authentication Token.`,
  },
  validations: {
    required: `{thing} is required`,
    failed: `Validation Failed`,
    'correct-issues': `Correct the indicated issues.`,
    'mbps-value-range': `Enter a value between {min} and {max} Mbps`,
    'min-length': `Minimum length 0 characters | Minimum length 1 character | Minimum length {min} characters`,
    'max-length': `Maximum length 0 characters | Maximum length 1 character | Maximum length {max} characters`,
    'weak-password': `Your password is not strong enough`,
    'new-password': `Enter your new password`,
    'password-different': `New password must be different from the old one`,
    'destination-provider': `Select the destination provider`,
    'please-select': `Please select the {thing}`,
    'enter-name': `Enter a name`,
    'confirm-password-mismatch': `The password does not match the provided password above`,
    'mfa-token': `Enter your MFA token`,
    'lag-speeds': `No Port speeds < 10Gbps in LAG`,
    'please-correct-issues': `Please correct the indicated issues.`,
    'invalid-type': `{field} must be a valid {type}`,
    'min-number': `Must have at least 1 number`,
    'min-upper-case': `Must have at least 1 upper case character`,
    'min-lower-case': `Must have at least 1 lower case character`,
    'min-symbol': `Must have at least 1 symbol character`,
  },
  connections: {
    cloud: `Cloud`,
    'internet-exchange': `Internet Exchange`,
    private: `Private`,
    marketplace: `Marketplace`,
    'connection-name': `Connection Name`,
    deleted: `Connection Deleted`,
    save: `Save Connection`,
    'add-connection': `Add Connection`,
    'select-connection-type': `Select Connection Type`,
    connection: `Connection`,
    remove: `Remove Connection`,
    new: `New Connection`,
    'confirm-remove': `Are you sure you want to remove this connection?`,
    editor: `{type} Editor`,
    'private-vxc-editor': `Private VXC Editor`,
    'marketplace-vxc-editor': `Marketplace VXC Editor`,
    'cloud-vxc-editor': `Cloud VXC Editor`,
    'destination-ix': `Destination IX`,
    'destination-ix-location': `Destination IX Location`,
    'choose-ix-location': `Choose IX Location`,
    'choose-cloud-provider': `Choose Cloud Provider`,
    'choose-marketplace-provider': `Choose Marketplace Provider`,
    'marketplace-provider': `Marketplace Provider`,
    'destination-location': `Destination Location`,
    'port-location': `Port Location`,
    'choose-location': `Choose Location`,
    'select-location-first': `Please select location first`,
    'locations-count': `{count} locations`,
    'locations-type-count': `0 {type} locations | 1 {type} location | {count} {type} locations`,
    'no-megaport-internet': `No Megaport Internet available at this location`,
    'transit-vxc-deleted-no-target': `Megaport Internet VXC of name {connectionName} was deleted as a suitable Megaport Internet destination in the new market was not found.`,
    'transit-vxc-deleted-market-not-enabled': `Megaport Internet VXC of name {connectionName} was deleted as the new location is not in a Megaport Internet enabled market.`,
    edit: `Edit Connection`,
    'deleting-error': `Error Deleting Connection`,
    'deleting-error-long': `Failed to delete connection with name: {connectionName}`,
    'unknown-connection-type': `Unknown Connection Type`,
    'unknown-connection-type-long': `Connection type {connectionType} is not supported. Connection will be treated as a new connection.`,
    'rate-limit-request-error': `Error Retrieving Rate Limits`,
    'rate-limit-request-error-long': `Failed to retrieve rate limits for this location. Please try again.`,
    'exclude-type-from-quote': `Exclude {connectionType} from quote`,
    'exclude-type-help-text': `Exclude this {connectionType} if you need it configured to replicate a particular network design without including its cost in the quote.`,
  },
  ports: {
    'port-speed': `Port Speed`,
    'percent-allocated': `{percent}% allocated`,
    'lacp-ports': `LACP & LAG Ports`,
    'lacp-on-port': `LACP on Port`,
    'ports-in-lag': `Number of Ports in LAG`,
    'count-port-lag': ` | 1 LAG Port | {count} LAG Ports`,
    vendor: `Vendor`,
    'minimum-term': `Minimum Term`,
    'mve-select-vendor': `Select Vendor`,
    'mve-location': `MVE Location`,
    'create-lacp-info': `Creates this Port with the LACP protocol enabled so it can be used on a Link Aggregation Group (LAG) and allows you to specify the number of ports to include in your LAG.`,
    'ports-to-lag-info': `This will add multiple Ports on this Link Aggregation Group (LAG). Pricing displayed is for all the ports being added to the LAG.`,
    'number-lag': `Number of LAG Ports`,
    'service-term': `Service Term`,
    'cross-connect': `Cross Connect`,
    'include-cross-connect': `Include Cross Connect`,
    'cross-connect-termed-ports': `Megaport can provision a Cross Connect at certain data center locations on your behalf for Ports ordered on term.`,
    'cross-connect-fees-vary': `Fees vary by data center location.`,
    'cross-connect-information-refer-documentation': `For more information, refer to our <a href="https://docs.megaport.com/connections/creating-port/" target="_blank">documentation</a>.`,
    'cross-connect-disclaimer': `A Cross Connect is available on 12 month minimum term at this location.`,
    'cross-connect-not-available': `Cross Connect is not available at this location. Contact your Account Manager to discuss options.`,
    'cross-connect-select-location-for-availability': `Please select a location and port speed to determine Cross Connect availability.`,
    'cross-connect-price-not-available': `Cross Connect is available at this location, but pricing is unavailable at this time. Please contact your Account Manager.`,
    'includes-cross-connect': `Includes Cross Connect`,
  },
  menu: {
    'user-menu': `User Menu`,
  },
  checkout: {
    'save-failed': `Failed to save configured services`,
  },
  users: {
    'save-failed': `Save Failed`,
  },
  pricebook: {
    'monthly-rate': `Monthly Rate`,
    'excludes-tax': `Price Excludes Tax`,
    subtotal: `Subtotal`,
    disclaimer: `This quote is non-binding and subject to change. It is provided for information only and is not an offer capable of acceptance. Taxes are excluded.`,
    'per-month-subscript': `per month`,
    'one-time-fee-subscript': `one-time fee`,
    'one-time-fee': `One-Time Fee`,
    'one-time-fees-subtotal': `One-Time Fees Subtotal`,
    'one-time-fees-total': `One-Time Fees Total`,
    'monthly-total': `Monthly Total`,
    'term-discount': `Term Discount`,
    'wholesale-discount': `Wholesale Discount`,
    'partner-discount': `Partner Discount`,
    'partner-managed-discount': `Partner Discount`,
    'reseller-discount': `Reseller Discount`, // API: This can be deleted once the FF reseller_discount_charge is removed at an API level
    'pricing-request-error': `Error Retrieving Pricing`,
    'pricing-request-error-long': `Failed to retrieve pricing for product of type: {productType}.`,
  },
  aws: {
    'hosted-vif': `Hosted VIF`,
    'hosted-connection': `Hosted Connection`,
  },
  'looking-glass': {
    'select-ix': `Select IX`,
  },
  'google-login': {
    failed: `Google Login Failed`,
    'failed-message': `Failed to log you in using Google.`,
  },
  partner: {
    'company-uid': `Company UID`,
    'managed-account': `Managed Account`,
    'existing-managed-account': `Existing Managed Account`,
    'new-managed-account': `New Managed Account`,
    'select-account': `Select Account`,
    'filter-account': `Filter accounts by name or reference`,
    'no-matching-accounts': `No matching accounts`,
  },
  'partner-admin': {
    'partner-account': `Partner Account`,
  },
  'app-info': {
    'name-short': `Quoting Tool`,
    version: `Version`,
  },
  'partner-vantage': {
    'save-deal-id': `Save Deal ID`,
    'deal-id': `Deal ID`,
    'deal-summary': `Deal Summary`,
    'copy-summary': `Copy Summary`,
    'send-to-register-summary': `When you register the quote in VantageHub a Deal ID will be provided once the deal is approved. Please enter the Deal ID to complete the quote.`,
    'deal-quote-service-required': `Deal quote must contain at least one service.`,
    'already-registered': `Quote has already been registered, generate a new quote to register against a deal.`,
    'register-failed': `Failed to register your Deal ID`,
    'deal-summary-line-monthly': `{amount} / Monthly `,
    'deal-summary-line-one-time': `{oneTimeFee} / One-Time Fee`,
    'redundant-action': `Redundant Action`,
    'empty-quote': `Empty Quote`,
  },
  quote: {
    'create-new': `Create New Quote`,
    name: `Quote Name`,
    'default-name': `{company} Quote`,
    saved: `Quote Saved`,
    id: `Quote ID`,
    'loading-error': `Error Loading Quote`,
    'loading-error-long': `Failed to load quote with ID: {quoteId}`,
    'downloading-csv-error': `Error Downloading CSV`,
    'downloading-csv-error-long': `Failed to download the CSV version of your quote`,
    'dirty-exit': `Your configuration has unsaved changes. Would you like to save them before you exit?`,
    'confirm-delete': `Are you sure you want to delete this quote?`,
    'confirm-duplicate-title': `Duplicate Quote?`,
    'confirm-duplicate': `This action will duplicate the current quote into the {megaportCompanyName} company. Do you wish to proceed?`,
    'deleting-error': `Error Deleting Quote`,
    'deleting-error-long': `Failed to delete quote with ID: {quoteId}`,
    'quote-deleted': `Quote Deleted`,
    'quote-deleted-long': `Quote with ID: {quoteId} has been successfully deleted`,
    'duplicating-error': `Error Duplicating Quote`,
    'duplicating-error-long': `Failed to duplicate quote with ID: {quoteId}`,
    'quote-duplicated': `Quote Duplicated`,
    'quote-duplicated-long': `Quote with ID: {quoteId} has been successfully duplicated`,
    builder: `Quote Builder`,
    provider: `Quote Provider`,
    'excluded-items-disclaimer': `This quote contains items whose related costs have been excluded. These or equivalent items are dependencies of the quote and required for the designed network configuration. Please contact your Megaport representative for more information.`,
    'saving-error': `Error Saving Quote`,
    'saving-error-long': `Failed to save quote with ID: {quoteId}`,
    'include-wholesale-discounts': `Include Wholesale Discounts`,
    'include-partner-discounts': `Include Partner Discounts`,
    'roll-up-discounts': `Roll Up Discounts`,
  },
  quotes: {
    saved: `Saved Quotes`,
    'short-description-own-company': `View a list of your quotes. Here you can create, save and forward new quotes. Quotes will be deleted after 6 months.`,
    'short-description-external-company': `You are viewing quotes created by {companyName}. Here you can view or duplicate their existing quotes. Duplicated quotes are saved in the {megaportCompanyName} company.`,
    'loading-error': `Error Loading Quotes`,
    'loading-error-long': `Failed to load saved quotes`,
    search: `Search Quotes`,
    view: `View Quotes`,
    'company-name-quotes': `{companyName} Quotes`,
    refresh: `Refresh Quotes`,
  },
  print: {
    'print-pdf': `Print PDF`,
    'registered-date': `Registered Date`,
    'network-config-heading': `Network Design Configuration`,
    'column-service-type': `Service Type`,
    'column-service-configuration': `Service Configuration`,
    connections: `Connections`,
  },
  'new-quote': {
    'target-type-help-text': `Please select the type of {target} you are creating a quote for.`,
    'target-type-customer': `customer`,
    'target-type-account': `account`,
    'company-fetch-error-title': `Error retrieving company details`,
    'company-fetch-error': `Failed to fetch list of companies`,
    'company-fetch-success': `Company details have been successfully retrieved`,
    'company-name-input-help-text': `You can provide a company name for future reference and added personalisation`,
    'company-name-select-help-text': `Please search for your target company by its ID or Trading Name`,
    'no-companies-found': `No companies found`,
    'select-company': `Select Company`,
    'company-search-placeholder': `Search by Company Trading Name or ID`,
    'target-company': `Target Company`,
    'start-typing-search': `Please start typing to search`,
  },
  company: {
    'search-company-quotes': `Search Company Quotes`,
    'show-deactivated-companies': `Show Deactivated Companies`,
    search: `Company Search`,
    'search-description': `Select a company below to view their list of quotes. While you cannot modify their existing quotes, you can duplicate any quote to the {megaportCompanyName} company for editing purposes.`,
    'search-error-title': `Error retrieving company quotes`,
    'search-error': `Company has already been added`,
    'remove-error-title': `Error removing company`,
    'remove-error': `Failed to remove company from the list of quotes`,
    'company-loading-error': `Error Loading Company Details`,
    'target-company-loading-error-long': `Failed to load target company details`,
  },
}
